// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_row__Pf-qY > div {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 0.5rem; }
  .styles_row__Pf-qY > div h2, .styles_row__Pf-qY > div h4 {
    margin: unset; }

.styles_grid__kxoi- {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  margin-top: 1rem; }

.styles_title__eKVl2 {
  margin: 0.5rem 0.9rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Features/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB,EAAA;EAN1B;IAQY,aACJ,EAAA;;AAIR;EACI,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,gBACJ,EAAA;;AAEA;EACI,qBACJ,EAAA","sourcesContent":[".row {\n    & > div {\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-end;\n        margin-top: 0.5rem;\n        & h2, h4 {\n            margin: unset\n        }\n    }\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    grid-gap: 1rem;\n    margin-top: 1rem\n}\n\n.title {\n    margin: 0.5rem 0.9rem\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `styles_row__Pf-qY`,
	"grid": `styles_grid__kxoi-`,
	"title": `styles_title__eKVl2`
};
export default ___CSS_LOADER_EXPORT___;
